import { api } from '../../../servicesGlobais/api'
import { PendenciaDto, PendenciaHistoricoDto, CriarPendenciaDto, AtualizarPendenciaDto } from '../tipos/pendencia'

function extractErrorMessage(error: any, defaultMessage: string): string {
  if (error?.response?.data) {
    const data = error.response.data
    if (typeof data === 'string') return data
    if (data.message) return data.message
    if (data.error) return data.error
  }
  return error?.message || defaultMessage
}

export const pendenciaService = {
  async obterPendencias(somenteNaoLidas = false, page = 1, pageSize = 20): Promise<PendenciaDto[]> {
    try {
      return await api.get(`/pendencias?somenteNaoLidas=${somenteNaoLidas}&page=${page}&pageSize=${pageSize}`)
    } catch (error) {
      throw new Error(extractErrorMessage(error, 'Erro ao buscar pendências'))
    }
  },

  async contarNaoLidas(): Promise<number> {
    try {
      const response = await api.get<{ count: number }>('/pendencias/contar-nao-lidas')
      return response.count
    } catch (error) {
      throw new Error(extractErrorMessage(error, 'Erro ao contar pendências não lidas'))
    }
  },

  async obterPorId(id: number): Promise<PendenciaDto> {
    try {
      return await api.get(`/pendencias/${id}`)
    } catch (error) {
      throw new Error(extractErrorMessage(error, 'Erro ao buscar pendência'))
    }
  },

  async criarPendencia(dto: CriarPendenciaDto): Promise<PendenciaDto> {
    try {
      return await api.post('/pendencias', dto)
    } catch (error) {
      throw new Error(extractErrorMessage(error, 'Erro ao criar pendência'))
    }
  },

  async atualizarPendencia(id: number, dto: AtualizarPendenciaDto): Promise<PendenciaDto> {
    try {
      return await api.put(`/pendencias/${id}`, dto)
    } catch (error) {
      throw new Error(extractErrorMessage(error, 'Erro ao atualizar pendência'))
    }
  },

  async marcarComoLida(id: number): Promise<void> {
    try {
      await api.patch(`/pendencias/${id}/marcar-lida`)
    } catch (error) {
      throw new Error(extractErrorMessage(error, 'Erro ao marcar pendência como lida'))
    }
  },

  async obterHistorico(id: number): Promise<PendenciaHistoricoDto[]> {
    try {
      return await api.get(`/pendencias/${id}/historico`)
    } catch (error) {
      throw new Error(extractErrorMessage(error, 'Erro ao buscar histórico'))
    }
  }
}



